
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb55d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb55d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9KTfg", function(module, exports) {
const $71a3437bf3b92af1$var$codeFencePattern = /```[^\r\n]*\r?\n([\s\S]*?)```/g;
function $71a3437bf3b92af1$var$parseCodeBlocks(answer) {
    const segments = [];
    let lastIndex = 0;
    let match;
    $71a3437bf3b92af1$var$codeFencePattern.lastIndex = 0;
    while((match = $71a3437bf3b92af1$var$codeFencePattern.exec(answer)) !== null){
        if (match.index > lastIndex) segments.push({
            type: 'text',
            value: answer.slice(lastIndex, match.index)
        });
        segments.push({
            type: 'code',
            value: match[1].replace(/\r?\n$/, '')
        });
        lastIndex = $71a3437bf3b92af1$var$codeFencePattern.lastIndex;
    }
    if (lastIndex < answer.length) segments.push({
        type: 'text',
        value: answer.slice(lastIndex)
    });
    return segments;
}
function $71a3437bf3b92af1$var$renderSafeAnswer(element, answer, onCopy) {
    const document = element.ownerDocument || globalThis.document;
    element.replaceChildren();
    for (const segment of $71a3437bf3b92af1$var$parseCodeBlocks(answer)){
        if (segment.type === 'text') {
            element.appendChild(document.createTextNode(segment.value));
            continue;
        }
        const wrapper = document.createElement('div');
        wrapper.className = 'div';
        const copyContainer = document.createElement('div');
        copyContainer.className = 'copy-container';
        const copyButton = document.createElement('button');
        copyButton.type = 'button';
        const copyIcon = document.createElement('i');
        copyIcon.className = 'fi fi-rr-clipboard';
        copyButton.appendChild(copyIcon);
        copyButton.appendChild(document.createTextNode(' Copy!'));
        const pre = document.createElement('pre');
        const code = document.createElement('code');
        code.textContent = segment.value;
        pre.appendChild(code);
        copyButton.addEventListener('click', ()=>onCopy(code));
        copyContainer.appendChild(copyButton);
        wrapper.appendChild(copyContainer);
        wrapper.appendChild(pre);
        element.appendChild(wrapper);
    }
}
module.exports = {
    parseCodeBlocks: $71a3437bf3b92af1$var$parseCodeBlocks,
    renderSafeAnswer: $71a3437bf3b92af1$var$renderSafeAnswer
};

});

parcelRegister("gUM5w", function(module, exports) {
// Keep the requested output budget small enough for provider-side request validation.
const $c5072d957efa7703$var$MAX_COMPLETION_TOKENS = 1024;
const $c5072d957efa7703$var$MAX_HISTORY_CHARACTERS = 1200;
const $c5072d957efa7703$var$MAX_CONTINUATION_CHARACTERS = 1200;
const $c5072d957efa7703$var$MAX_COMPACT_CHARACTERS = 250;
const $c5072d957efa7703$var$MAX_EMERGENCY_COMPACT_CHARACTERS = 100;
const $c5072d957efa7703$var$MAX_REQUEST_BODY_BYTES = 2048;
const $c5072d957efa7703$var$MAX_RESPONSE_CONTINUATIONS = 1;
const $c5072d957efa7703$var$CONTINUATION_PROMPT = 'Continue the response exactly where it stopped. Do not repeat any text. Output only the continuation.';
const $c5072d957efa7703$var$CONTENT_TRUNCATION_MARKER = '\n\n[Earlier content trimmed to fit the request size.]\n\n';
function $c5072d957efa7703$var$clipContent(content, maxCharacters) {
    if (content.length <= maxCharacters) return content;
    if (maxCharacters <= 0) return '';
    if (maxCharacters <= $c5072d957efa7703$var$CONTENT_TRUNCATION_MARKER.length) return content.slice(0, maxCharacters);
    const availableCharacters = maxCharacters - $c5072d957efa7703$var$CONTENT_TRUNCATION_MARKER.length;
    const headCharacters = Math.ceil(availableCharacters / 2);
    const tailCharacters = availableCharacters - headCharacters;
    return `${content.slice(0, headCharacters)}${$c5072d957efa7703$var$CONTENT_TRUNCATION_MARKER}${content.slice(-tailCharacters)}`;
}
function $c5072d957efa7703$var$getUtf8ByteLength(value) {
    if (typeof TextEncoder === 'function') return new TextEncoder().encode(value).length;
    return value.length;
}
function $c5072d957efa7703$var$selectRecentHistory(history, maxCharacters = $c5072d957efa7703$var$MAX_HISTORY_CHARACTERS) {
    const recentHistory = [];
    let historyCharacters = 0;
    for(let index = history.length - 1; index >= 0; index--){
        const message = history[index];
        if (!message || ![
            'user',
            'assistant'
        ].includes(message.role) || typeof message.content !== 'string') continue;
        const remainingCharacters = maxCharacters - historyCharacters;
        if (remainingCharacters <= 0) break;
        if (recentHistory.length > 0 && message.content.length > remainingCharacters) break;
        const content = $c5072d957efa7703$var$clipContent(message.content, remainingCharacters);
        recentHistory.unshift({
            role: message.role,
            content: content
        });
        historyCharacters += content.length;
        if (content.length < message.content.length) break;
    }
    return recentHistory;
}
function $c5072d957efa7703$var$buildConversationMessages(systemPrompt, history, maxCharacters = $c5072d957efa7703$var$MAX_HISTORY_CHARACTERS) {
    return [
        {
            role: 'system',
            content: systemPrompt
        },
        ...$c5072d957efa7703$var$selectRecentHistory(history, maxCharacters)
    ];
}
function $c5072d957efa7703$var$buildCompactConversationMessages(messages, maxCharacters = $c5072d957efa7703$var$MAX_COMPACT_CHARACTERS) {
    const systemMessage = messages.find((message)=>message?.role === 'system');
    const nonSystemMessages = messages.filter((message)=>message?.role !== 'system');
    const continuationMessage = nonSystemMessages.at(-1);
    const isContinuation = continuationMessage?.role === 'user' && continuationMessage.content === $c5072d957efa7703$var$CONTINUATION_PROMPT;
    const latestUserMessage = isContinuation ? [
        ...nonSystemMessages
    ].reverse().find((message)=>message?.role === 'user' && message !== continuationMessage) : [
        ...nonSystemMessages
    ].reverse().find((message)=>message?.role === 'user');
    const compactMessages = systemMessage ? [
        {
            role: 'system',
            content: systemMessage.content
        }
    ] : [];
    if (!isContinuation) {
        if (latestUserMessage) compactMessages.push({
            role: 'user',
            content: $c5072d957efa7703$var$clipContent(latestUserMessage.content, maxCharacters)
        });
        return compactMessages;
    }
    const latestAssistantMessage = [
        ...nonSystemMessages
    ].reverse().find((message)=>message?.role === 'assistant');
    const availableCharacters = Math.max(0, maxCharacters - $c5072d957efa7703$var$CONTINUATION_PROMPT.length);
    const userCharacters = Math.floor(availableCharacters / 2);
    const assistantCharacters = availableCharacters - userCharacters;
    if (latestUserMessage) compactMessages.push({
        role: 'user',
        content: $c5072d957efa7703$var$clipContent(latestUserMessage.content, userCharacters)
    });
    if (latestAssistantMessage) compactMessages.push({
        role: 'assistant',
        content: $c5072d957efa7703$var$clipContent(latestAssistantMessage.content, assistantCharacters)
    });
    compactMessages.push({
        role: 'user',
        content: $c5072d957efa7703$var$CONTINUATION_PROMPT
    });
    return compactMessages;
}
function $c5072d957efa7703$var$fitRequestToBodyLimit(messages, serializeRequest) {
    let requestMessages = messages;
    let requestBody = serializeRequest(requestMessages);
    const characterLimits = [
        $c5072d957efa7703$var$MAX_COMPACT_CHARACTERS,
        $c5072d957efa7703$var$MAX_EMERGENCY_COMPACT_CHARACTERS,
        0
    ];
    if ($c5072d957efa7703$var$getUtf8ByteLength(requestBody) <= $c5072d957efa7703$var$MAX_REQUEST_BODY_BYTES) return {
        messages: requestMessages,
        body: requestBody,
        fits: true
    };
    for (const maxCharacters of characterLimits){
        requestMessages = $c5072d957efa7703$var$buildCompactConversationMessages(messages, maxCharacters);
        requestBody = serializeRequest(requestMessages);
        if ($c5072d957efa7703$var$getUtf8ByteLength(requestBody) <= $c5072d957efa7703$var$MAX_REQUEST_BODY_BYTES) return {
            messages: requestMessages,
            body: requestBody,
            fits: true
        };
    }
    return {
        messages: requestMessages,
        body: requestBody,
        fits: $c5072d957efa7703$var$getUtf8ByteLength(requestBody) <= $c5072d957efa7703$var$MAX_REQUEST_BODY_BYTES
    };
}
function $c5072d957efa7703$var$buildContinuationMessages(messages, answer, maxCharacters = $c5072d957efa7703$var$MAX_CONTINUATION_CHARACTERS) {
    const systemMessage = messages.find((message)=>message?.role === 'system');
    const history = messages.filter((message)=>message?.role !== 'system');
    const continuationAnswer = typeof answer === 'string' ? $c5072d957efa7703$var$clipContent(answer, maxCharacters) : '';
    const historyCharacters = Math.max(0, maxCharacters - continuationAnswer.length);
    return [
        ...systemMessage ? [
            {
                role: 'system',
                content: systemMessage.content
            }
        ] : [],
        ...$c5072d957efa7703$var$selectRecentHistory(history, historyCharacters),
        ...continuationAnswer ? [
            {
                role: 'assistant',
                content: continuationAnswer
            }
        ] : [],
        {
            role: 'user',
            content: $c5072d957efa7703$var$CONTINUATION_PROMPT
        }
    ];
}
function $c5072d957efa7703$var$getResponseParts(message) {
    let answer = typeof message?.content === 'string' ? message.content : '';
    let reasoning = typeof message?.reasoning === 'string' ? message.reasoning : '';
    if (!reasoning && typeof message?.reasoning_content === 'string') reasoning = message.reasoning_content;
    const thinkBlock = /<think(?:ing)?\b[^>]*>([\s\S]*?)<\/think(?:ing)?\s*>/gi;
    answer = answer.replace(thinkBlock, function(match, thought) {
        const trimmedThought = thought.trim();
        if (trimmedThought) reasoning = reasoning ? `${reasoning}\n\n${trimmedThought}` : trimmedThought;
        return '';
    }).trim();
    return {
        answer: answer,
        reasoning: reasoning.trim()
    };
}
function $c5072d957efa7703$var$mergeResponseParts(current, next) {
    const reasoning = [
        current.reasoning,
        next.reasoning
    ].filter(Boolean).join('\n\n');
    const separator = current.answer && next.answer && !/\s$/.test(current.answer) && !/^\s/.test(next.answer) ? '\n' : '';
    return {
        answer: `${current.answer || ''}${separator}${next.answer || ''}`,
        reasoning: reasoning
    };
}
module.exports = {
    CONTINUATION_PROMPT: $c5072d957efa7703$var$CONTINUATION_PROMPT,
    MAX_COMPLETION_TOKENS: $c5072d957efa7703$var$MAX_COMPLETION_TOKENS,
    MAX_CONTINUATION_CHARACTERS: $c5072d957efa7703$var$MAX_CONTINUATION_CHARACTERS,
    MAX_EMERGENCY_COMPACT_CHARACTERS: $c5072d957efa7703$var$MAX_EMERGENCY_COMPACT_CHARACTERS,
    MAX_HISTORY_CHARACTERS: $c5072d957efa7703$var$MAX_HISTORY_CHARACTERS,
    MAX_COMPACT_CHARACTERS: $c5072d957efa7703$var$MAX_COMPACT_CHARACTERS,
    MAX_REQUEST_BODY_BYTES: $c5072d957efa7703$var$MAX_REQUEST_BODY_BYTES,
    MAX_RESPONSE_CONTINUATIONS: $c5072d957efa7703$var$MAX_RESPONSE_CONTINUATIONS,
    buildContinuationMessages: $c5072d957efa7703$var$buildContinuationMessages,
    buildCompactConversationMessages: $c5072d957efa7703$var$buildCompactConversationMessages,
    buildConversationMessages: $c5072d957efa7703$var$buildConversationMessages,
    fitRequestToBodyLimit: $c5072d957efa7703$var$fitRequestToBodyLimit,
    getResponseParts: $c5072d957efa7703$var$getResponseParts,
    getUtf8ByteLength: $c5072d957efa7703$var$getUtf8ByteLength,
    mergeResponseParts: $c5072d957efa7703$var$mergeResponseParts,
    selectRecentHistory: $c5072d957efa7703$var$selectRecentHistory
};

});


var $9KTfg = parcelRequire("9KTfg");
var $4518a379e0f7f99a$require$renderSafeAnswer = $9KTfg.renderSafeAnswer;

var $gUM5w = parcelRequire("gUM5w");
var $4518a379e0f7f99a$require$MAX_COMPLETION_TOKENS = $gUM5w.MAX_COMPLETION_TOKENS;
var $4518a379e0f7f99a$require$MAX_EMERGENCY_COMPACT_CHARACTERS = $gUM5w.MAX_EMERGENCY_COMPACT_CHARACTERS;
var $4518a379e0f7f99a$require$MAX_REQUEST_BODY_BYTES = $gUM5w.MAX_REQUEST_BODY_BYTES;
var $4518a379e0f7f99a$require$MAX_RESPONSE_CONTINUATIONS = $gUM5w.MAX_RESPONSE_CONTINUATIONS;
var $4518a379e0f7f99a$require$buildContinuationMessages = $gUM5w.buildContinuationMessages;
var $4518a379e0f7f99a$require$buildCompactConversationMessages = $gUM5w.buildCompactConversationMessages;
var $4518a379e0f7f99a$require$buildConversationMessages = $gUM5w.buildConversationMessages;
var $4518a379e0f7f99a$require$fitRequestToBodyLimit = $gUM5w.fitRequestToBodyLimit;
var $4518a379e0f7f99a$require$getResponseParts = $gUM5w.getResponseParts;
var $4518a379e0f7f99a$require$getUtf8ByteLength = $gUM5w.getUtf8ByteLength;
var $4518a379e0f7f99a$require$mergeResponseParts = $gUM5w.mergeResponseParts;
//DOM Elementes needed for this to work
var $4518a379e0f7f99a$var$chatBox = document.getElementById('displayMessages');
var $4518a379e0f7f99a$var$chatInput = document.getElementById('userInput');
var $4518a379e0f7f99a$var$sendButton = document.getElementById('sendButton');
//Checks if screen width is more than 481 px
if (window.innerWidth < 481) {
    const notice = document.createElement('h1');
    notice.className = 'text-center display-4';
    notice.textContent = 'Please use a larger screen to view the chatbot.';
    $4518a379e0f7f99a$var$chatBox.replaceChildren(notice);
}
//API Key
var $4518a379e0f7f99a$var$apiKey = "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";
var $4518a379e0f7f99a$var$chatHistory = [];
const $4518a379e0f7f99a$var$systemPrompt = 'EXTREMELY IMPORTANT: Always put code inside triple backticks. Only answer the last question the user asks. Do not mention conversation history. You are a very helpful coder, programmer, and developer with strong knowledge of computer science and programming languages. Reply with emojis if you can.';
function $4518a379e0f7f99a$var$createThinkingBlock(reasoning) {
    const details = document.createElement('details');
    details.className = 'message-thinking';
    const summary = document.createElement('summary');
    summary.textContent = 'Thinking process';
    const content = document.createElement('div');
    content.className = 'message-thinking-content';
    content.textContent = reasoning;
    details.append(summary, content);
    return details;
}
function $4518a379e0f7f99a$var$appendUserMessage(userMessage) {
    const message = document.createElement('div');
    message.className = 'message-user';
    message.textContent = userMessage;
    $4518a379e0f7f99a$var$chatBox.appendChild(message);
}
function $4518a379e0f7f99a$var$appendAssistantPlaceholder() {
    const message = document.createElement('div');
    message.className = 'message-ai';
    message.textContent = '...';
    $4518a379e0f7f99a$var$chatBox.appendChild(message);
}
//Get Response from AI Model
async function $4518a379e0f7f99a$var$getResponse(userMessage) {
    //API URL
    const apiUrl = 'https://api.groq.com/openai/v1/chat/completions';
    const aiResponseMessage = $4518a379e0f7f99a$var$chatBox.lastElementChild;
    if (!$4518a379e0f7f99a$var$apiKey) {
        aiResponseMessage.textContent = 'AI Code is not configured. Add CHATBOT_API_KEY to the Netlify build environment and redeploy.';
        return;
    }
    $4518a379e0f7f99a$var$chatHistory.push({
        role: 'user',
        content: userMessage
    });
    try {
        const responseParts = await $4518a379e0f7f99a$var$getCompleteResponse(apiUrl, $4518a379e0f7f99a$require$buildConversationMessages($4518a379e0f7f99a$var$systemPrompt, $4518a379e0f7f99a$var$chatHistory));
        const aiResponse = responseParts.answer;
        aiResponseMessage.replaceChildren();
        if (responseParts.reasoning) aiResponseMessage.appendChild($4518a379e0f7f99a$var$createThinkingBlock(responseParts.reasoning));
        const answerElement = document.createElement('div');
        answerElement.className = 'message-answer';
        aiResponseMessage.appendChild(answerElement);
        let speed = 5;
        if (aiResponse.length > 250) speed = 15;
        else if (aiResponse.length > 100) speed = 7;
        $4518a379e0f7f99a$var$typeEffect(answerElement, aiResponse, speed, ()=>{
            if (responseParts.incomplete) $4518a379e0f7f99a$var$appendIncompleteNotice(aiResponseMessage);
        });
        $4518a379e0f7f99a$var$chatHistory.push({
            role: 'assistant',
            content: responseParts.answer
        });
        $4518a379e0f7f99a$var$chatBox.scrollTop = $4518a379e0f7f99a$var$chatBox.scrollHeight;
    } catch (error) {
        //Catch errors and display error message
        aiResponseMessage.textContent = 'Oops! Something went wrong. Try again later!';
        Swal.fire({
            title: "Error!",
            customClass: {
                title: 'black'
            },
            text: "Do you want to continue",
            icon: 'error',
            iconColor: '#FF642C',
            color: 'black',
            confirmButtonText: 'OK',
            confirmButtonColor: '#FF642C',
            timer: 5000,
            timerProgressBar: true
        });
    }
}
async function $4518a379e0f7f99a$var$requestCompletion(apiUrl, messages) {
    const createRequestBody = (requestMessages)=>JSON.stringify({
            model: "qwen/qwen3.6-27b",
            messages: requestMessages,
            temperature: 1,
            top_p: 1,
            stream: false,
            reasoning_effort: "default",
            reasoning_format: "parsed",
            max_completion_tokens: $4518a379e0f7f99a$require$MAX_COMPLETION_TOKENS
        });
    const request = (requestBody)=>fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${$4518a379e0f7f99a$var$apiKey}`
            },
            body: requestBody
        });
    let { messages: requestMessages, body: requestBody, fits: fits } = $4518a379e0f7f99a$require$fitRequestToBodyLimit(messages, createRequestBody);
    if (!fits || $4518a379e0f7f99a$require$getUtf8ByteLength(requestBody) > $4518a379e0f7f99a$require$MAX_REQUEST_BODY_BYTES) throw new Error('Unable to fit the chat request within the provider size limit.');
    let response = await request(requestBody);
    if (response.status === 413) {
        const compactMessages = $4518a379e0f7f99a$require$buildCompactConversationMessages(requestMessages, $4518a379e0f7f99a$require$MAX_EMERGENCY_COMPACT_CHARACTERS);
        const compactBody = createRequestBody(compactMessages);
        if (compactBody !== requestBody) response = await request(compactBody);
    }
    const data = await response.json();
    if (!response.ok) throw new Error(data?.error?.message || `Request failed with status ${response.status}`);
    const choice = data?.choices?.[0];
    if (!choice?.message) throw new Error('The API returned no assistant message.');
    return choice;
}
async function $4518a379e0f7f99a$var$getCompleteResponse(apiUrl, messages) {
    let requestMessages = messages;
    let combined = {
        answer: '',
        reasoning: ''
    };
    for(let attempt = 0; attempt <= $4518a379e0f7f99a$require$MAX_RESPONSE_CONTINUATIONS; attempt++){
        const choice = await $4518a379e0f7f99a$var$requestCompletion(apiUrl, requestMessages);
        combined = $4518a379e0f7f99a$require$mergeResponseParts(combined, $4518a379e0f7f99a$require$getResponseParts(choice.message));
        if (choice.finish_reason !== 'length' || attempt === $4518a379e0f7f99a$require$MAX_RESPONSE_CONTINUATIONS) return {
            ...combined,
            incomplete: choice.finish_reason === 'length'
        };
        requestMessages = $4518a379e0f7f99a$require$buildContinuationMessages(messages, combined.answer);
    }
}
function $4518a379e0f7f99a$var$typeEffect(element, text, speed, onComplete) {
    element.textContent = "";
    const typingCursor = document.createElement("span");
    typingCursor.classList.add("typing-cursor");
    element.appendChild(typingCursor);
    let index = 0;
    const chunkSize = text.length > 2500 ? 12 : 1;
    function type() {
        if (index < text.length) {
            index = Math.min(index + chunkSize, text.length);
            element.textContent = text.substring(0, index);
            setTimeout(type, speed);
            $4518a379e0f7f99a$var$chatBox.scrollTop = $4518a379e0f7f99a$var$chatBox.scrollHeight;
        } else {
            $4518a379e0f7f99a$require$renderSafeAnswer(element, text, $4518a379e0f7f99a$var$copyCode);
            onComplete();
        }
    }
    type();
}
function $4518a379e0f7f99a$var$appendIncompleteNotice(container) {
    const notice = document.createElement('div');
    notice.className = 'message-truncated';
    notice.textContent = "The response reached the output limit. Send \u201Ccontinue\u201D to finish it.";
    container.appendChild(notice);
}
//Event Listener for send Button
$4518a379e0f7f99a$var$sendButton.addEventListener('click', function() {
    var userInput = $4518a379e0f7f99a$var$chatInput.value;
    if (userInput === '') return;
    $4518a379e0f7f99a$var$appendUserMessage(userInput);
    $4518a379e0f7f99a$var$appendAssistantPlaceholder();
    //Call the function
    $4518a379e0f7f99a$var$getResponse(userInput);
    $4518a379e0f7f99a$var$chatInput.value = '';
    $4518a379e0f7f99a$var$chatBox.scrollTop = $4518a379e0f7f99a$var$chatBox.scrollHeight;
});
//Event listener for Enter key pressed
$4518a379e0f7f99a$var$chatInput.addEventListener('keypress', function(event) {
    if (event.key == 'Enter') {
        var userInput = $4518a379e0f7f99a$var$chatInput.value;
        if (userInput === '') return;
        $4518a379e0f7f99a$var$appendUserMessage(userInput);
        $4518a379e0f7f99a$var$appendAssistantPlaceholder();
        //Call the function
        $4518a379e0f7f99a$var$getResponse(userInput);
        $4518a379e0f7f99a$var$chatInput.value = '';
        $4518a379e0f7f99a$var$chatBox.scrollTop = $4518a379e0f7f99a$var$chatBox.scrollHeight;
    }
});
//Function to copy code from the AI Generated Code
function $4518a379e0f7f99a$var$copyCode(codeContent) {
    if (typeof codeContent === 'string') codeContent = document.getElementById(codeContent);
    if (!codeContent) return;
    window.navigator.clipboard.writeText(codeContent.textContent);
    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
        didOpen: (toast)=>{
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });
    Toast.fire({
        title: "Copied!",
        customClass: {
            title: 'black'
        },
        icon: 'success',
        iconColor: '#FF642C',
        color: 'black'
    });
}


//# sourceMappingURL=code.0ae4424a.js.map
